"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDraftExtendContext = exports.pluginUtils = exports.createPlugin = exports.compose = exports.accumulatePluginOptions = exports.Toolbar = exports.KeyCommandController = exports.Editor = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _draftJs = require("draft-js");
var _immutable = require("immutable");
var _reactDom = _interopRequireDefault(require("react-dom"));
const _excluded = ["editorState", "onChange", "keyCommandListeners"],
  _excluded2 = ["styleMap", "styleFn", "blockRendererFn", "blockStyleFn", "onChange", "handleKeyCommand"],
  _excluded3 = ["editorState", "onChange", "buttons", "addKeyCommandListener", "removeKeyCommandListener"],
  _excluded4 = ["__keyCommandListener"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
var NODE_ENV = process.env.NODE_ENV;
var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }
  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};
var invariant_1 = invariant;
const providedProps = {
  addKeyCommandListener: _propTypes.default.func,
  removeKeyCommandListener: _propTypes.default.func,
  handleKeyCommand: _propTypes.default.func
};
const KeyCommandController = Component => {
  class KeyCommand extends _react.default.Component {
    constructor(props) {
      super(props);
      this.addKeyCommandListener = this.addKeyCommandListener.bind(this);
      this.removeKeyCommandListener = this.removeKeyCommandListener.bind(this);
      this.handleKeyCommand = this.handleKeyCommand.bind(this);
      this.focus = this.focus.bind(this);
      this.blur = this.blur.bind(this);
    }
    UNSAFE_componentWillMount() {
      this.keyCommandOverrides = (0, _immutable.List)(this.props.keyCommandListeners);
      this.keyCommandListeners = (0, _immutable.List)();
    }
    componentDidMount() {
      // ensure valid props for deferral
      const propNames = Object.keys(providedProps);
      const presentProps = propNames.filter(propName => this.props[propName] !== undefined);
      const nonePresent = presentProps.length === 0;
      const allPresent = presentProps.length === propNames.length;
      invariant_1(nonePresent || allPresent, `KeyCommandController: A KeyCommandController is receiving only some props (${presentProps.join(', ')}) necessary to defer to a parent key command controller.`);
      if (allPresent) {
        this.props.keyCommandListeners.forEach(listener => {
          this.props.addKeyCommandListener(listener);
        });
      }
    }
    componentWillUnmount() {
      if (this.props.removeKeyCommandListener) {
        this.props.keyCommandListeners.forEach(listener => {
          this.props.removeKeyCommandListener(listener);
        });
      }
    }
    addKeyCommandListener(listener) {
      const {
        addKeyCommandListener
      } = this.props;
      if (addKeyCommandListener) {
        addKeyCommandListener(listener);
        return;
      }
      this.keyCommandListeners = this.keyCommandListeners.unshift(listener);
    }
    removeKeyCommandListener(listener) {
      const {
        removeKeyCommandListener
      } = this.props;
      if (removeKeyCommandListener) {
        removeKeyCommandListener(listener);
        return;
      }
      this.keyCommandListeners = this.keyCommandListeners.filterNot(l => l === listener);
    }
    handleKeyCommand(command, keyboardEvent = null) {
      const {
        editorState,
        onChange,
        handleKeyCommand
      } = this.props;
      if (handleKeyCommand) {
        return handleKeyCommand(command, keyboardEvent);
      }
      const result = this.keyCommandListeners.concat(this.keyCommandOverrides).reduce(({
        state,
        hasChanged
      }, listener) => {
        if (hasChanged === true) {
          return {
            state,
            hasChanged
          };
        }
        const listenerResult = listener(state, command, keyboardEvent);
        const isEditorState = listenerResult instanceof _draftJs.EditorState;
        if (listenerResult === true || isEditorState && listenerResult !== state) {
          if (isEditorState) {
            onChange(listenerResult);
            return {
              state: listenerResult,
              hasChanged: true
            };
          }
          return {
            state,
            hasChanged: true
          };
        }
        return {
          state,
          hasChanged
        };
      }, {
        state: editorState,
        hasChanged: false
      });
      return result.hasChanged;
    }
    focus() {
      this.refs.editor.focus();
    }
    blur() {
      this.refs.editor.blur();
    }
    render() {
      const _this$props = this.props,
        {
          editorState,
          onChange

          // eslint-disable-line no-unused-vars
        } = _this$props,
        others = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, others, {
        ref: "editor",
        editorState: editorState,
        onChange: onChange,
        addKeyCommandListener: this.addKeyCommandListener,
        removeKeyCommandListener: this.removeKeyCommandListener,
        handleKeyCommand: this.handleKeyCommand
      }));
    }
  }
  KeyCommand.displayName = `KeyCommandController(${Component.displayName})`;
  KeyCommand.propTypes = Object.assign({
    editorState: _propTypes.default.object,
    onChange: _propTypes.default.func,
    keyCommandListeners: _propTypes.default.arrayOf(_propTypes.default.func)
  }, providedProps);
  KeyCommand.defaultProps = {
    keyCommandListeners: []
  };
  return KeyCommand;
};
exports.KeyCommandController = KeyCommandController;
class OverlayWrapper extends _react.default.Component {
  constructor(props) {
    super(props);
    const node = document.createElement('div');
    document.body.appendChild(node);
    this.state = {
      node
    };
  }
  componentDidMount() {
    this.renderOverlay();
  }
  componentDidUpdate() {
    this.renderOverlay();
  }
  componentWillUnmount() {
    _reactDom.default.unmountComponentAtNode(this.state.node);
  }
  renderOverlay() {
    const child = _react.default.Children.only(this.props.children);
    _reactDom.default.render(child, this.state.node);
  }
  render() {
    return null;
  }
}
const propTypes = {
  className: _propTypes.default.string,
  editorState: _propTypes.default.object,
  onChange: _propTypes.default.func,
  decorators: _propTypes.default.array,
  baseDecorator: _propTypes.default.func,
  styleMap: _propTypes.default.object,
  styleFn: _propTypes.default.func,
  buttons: _propTypes.default.array,
  overlays: _propTypes.default.array,
  blockRendererFn: _propTypes.default.func,
  blockStyleFn: _propTypes.default.func,
  keyBindingFn: _propTypes.default.func,
  addKeyCommandListener: _propTypes.default.func.isRequired,
  removeKeyCommandListener: _propTypes.default.func.isRequired,
  handleReturn: _propTypes.default.func,
  onEscape: _propTypes.default.func,
  onTab: _propTypes.default.func,
  onUpArrow: _propTypes.default.func,
  onDownArrow: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  showButtons: _propTypes.default.bool,
  renderTray: _propTypes.default.func
};
class EditorWrapper extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      baseDecorator
    } = props;
    const decorator = new baseDecorator(props.decorators);
    this.state = {
      decorator,
      readOnly: false
    };
    this.keyBindingFn = this.keyBindingFn.bind(this);
    this.handleReturn = this.handleReturn.bind(this);
    this.onEscape = this.onEscape.bind(this);
    this.onTab = this.onTab.bind(this);
    this.onUpArrow = this.onUpArrow.bind(this);
    this.onDownArrow = this.onDownArrow.bind(this);
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.getOtherProps = this.getOtherProps.bind(this);
    this.getReadOnly = this.getReadOnly.bind(this);
    this.setReadOnly = this.setReadOnly.bind(this);
    this.getDecoratedState = this.getDecoratedState.bind(this);
  }
  getChildContext() {
    return {
      getEditorState: this.getDecoratedState,
      getReadOnly: this.getReadOnly,
      setReadOnly: this.setReadOnly,
      onChange: this.props.onChange,
      focus: this.focus,
      blur: this.blur,
      editorRef: this.refs.editor
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.decorators.length === this.state.decorator._decorators.length) {
      const allDecoratorsMatch = this.state.decorator._decorators.every((decorator, i) => {
        return decorator === nextProps.decorators[i];
      });
      if (allDecoratorsMatch) {
        return;
      }
    }
    this.setState({
      decorator: new nextProps.baseDecorator(nextProps.decorators)
    });
  }
  keyBindingFn(e) {
    const pluginsCommand = this.props.keyBindingFn(e);
    if (pluginsCommand) {
      return pluginsCommand;
    }
    return (0, _draftJs.getDefaultKeyBinding)(e);
  }
  handleReturn(e, editorState) {
    return this.props.handleReturn && this.props.handleReturn(e, editorState) || this.props.handleKeyCommand('return', e);
  }
  onEscape(e) {
    return this.props.onEscape && this.props.onEscape(e) || this.props.handleKeyCommand('escape', e);
  }
  onTab(e) {
    return this.props.onTab && this.props.onTab(e) || this.props.handleKeyCommand('tab', e);
  }
  onUpArrow(e) {
    return this.props.onUpArrow && this.props.onUpArrow(e) || this.props.handleKeyCommand('up-arrow', e);
  }
  onDownArrow(e) {
    return this.props.onDownArrow && this.props.onDownArrow(e) || this.props.handleKeyCommand('down-arrow', e);
  }
  focus() {
    this.refs.editor.focus();
  }
  blur() {
    this.refs.editor.blur();
  }
  getOtherProps() {
    const propKeys = Object.keys(this.props);
    const propTypeKeys = Object.keys(propTypes);
    const propsToPass = propKeys.filter(prop => {
      return propTypeKeys.indexOf(prop) === -1;
    });
    return propsToPass.reduce((acc, prop) => {
      acc[prop] = this.props[prop];
      return acc;
    }, {});
  }
  getReadOnly() {
    return this.state.readOnly || this.props.readOnly;
  }
  setReadOnly(readOnly) {
    this.setState({
      readOnly
    });
  }
  getDecoratedState() {
    const {
      editorState
    } = this.props;
    const {
      decorator
    } = this.state;
    const currentDecorator = editorState.getDecorator();
    if (currentDecorator && currentDecorator._decorators === decorator._decorators) {
      return editorState;
    }
    return _draftJs.EditorState.set(editorState, {
      decorator
    });
  }
  renderTray() {
    const {
      renderTray
    } = this.props;
    if (typeof renderTray !== 'function') {
      return null;
    }
    return renderTray();
  }
  renderPluginButtons() {
    const {
      onChange,
      addKeyCommandListener,
      removeKeyCommandListener,
      showButtons
    } = this.props;
    if (showButtons === false) {
      return null;
    }
    const decoratedState = this.getDecoratedState();
    return this.props.buttons.map((Button, index) => {
      return /*#__PURE__*/_react.default.createElement(Button, Object.assign({}, this.getOtherProps(), {
        key: `button-${index}`,
        attachedToEditor: true,
        editorState: decoratedState,
        onChange: onChange,
        addKeyCommandListener: addKeyCommandListener,
        removeKeyCommandListener: removeKeyCommandListener
      }));
    });
  }
  renderOverlays() {
    const {
      onChange,
      addKeyCommandListener,
      removeKeyCommandListener
    } = this.props;
    const decoratedState = this.getDecoratedState();
    return this.props.overlays.map((Overlay, index) => {
      return /*#__PURE__*/_react.default.createElement(OverlayWrapper, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(Overlay, Object.assign({}, this.getOtherProps(), {
        editorState: decoratedState,
        onChange: onChange,
        addKeyCommandListener: addKeyCommandListener,
        removeKeyCommandListener: removeKeyCommandListener
      })));
    });
  }
  render() {
    const _this$props2 = this.props,
      {
        styleMap,
        styleFn,
        blockRendererFn,
        blockStyleFn,
        onChange,
        handleKeyCommand
      } = _this$props2,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, _excluded2);
    const decoratedState = this.getDecoratedState();
    const className = `draft-extend ${this.props.className}`;
    const readOnly = this.getReadOnly();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "draft-extend-editor"
    }, /*#__PURE__*/_react.default.createElement(_draftJs.Editor, Object.assign({}, otherProps, {
      ref: "editor",
      editorState: decoratedState,
      readOnly: readOnly,
      onChange: onChange,
      blockStyleFn: blockStyleFn,
      blockRendererFn: blockRendererFn,
      customStyleMap: styleMap,
      customStyleFn: styleFn,
      handleKeyCommand: handleKeyCommand,
      keyBindingFn: this.keyBindingFn,
      handleReturn: this.handleReturn,
      onEscape: this.onEscape,
      onTab: this.onTab,
      onUpArrow: this.onUpArrow,
      onDownArrow: this.onDownArrow
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "draft-extend-tray"
    }, this.renderTray()), /*#__PURE__*/_react.default.createElement("div", {
      className: "draft-extend-controls"
    }, this.renderPluginButtons()), /*#__PURE__*/_react.default.createElement("div", {
      className: "draft-extend-overlays"
    }, this.renderOverlays())));
  }
}
EditorWrapper.propTypes = propTypes;
EditorWrapper.defaultProps = {
  className: '',
  editorState: _draftJs.EditorState.createEmpty(),
  onChange: () => {},
  decorators: [],
  baseDecorator: _draftJs.CompositeDecorator,
  styleMap: {},
  styleFn: () => {},
  buttons: [],
  overlays: [],
  blockRendererFn: () => {},
  blockStyleFn: () => {},
  keyBindingFn: () => {},
  readOnly: false,
  showButtons: true
};
EditorWrapper.childContextTypes = {
  getEditorState: _propTypes.default.func,
  getReadOnly: _propTypes.default.func,
  setReadOnly: _propTypes.default.func,
  onChange: _propTypes.default.func,
  focus: _propTypes.default.func,
  blur: _propTypes.default.func,
  editorRef: _propTypes.default.object
};
var Editor = exports.Editor = KeyCommandController(EditorWrapper);
class Toolbar extends _react.default.Component {
  constructor(props) {
    super(props);
    this.getEditorState = this.getEditorState.bind(this);
  }
  getChildContext() {
    return {
      getEditorState: this.getEditorState,
      onChange: this.props.onChange
    };
  }
  getEditorState() {
    return this.props.editorState;
  }
  renderButtons() {
    const _this$props3 = this.props,
      {
        editorState,
        onChange,
        buttons,
        addKeyCommandListener,
        removeKeyCommandListener
      } = _this$props3,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props3, _excluded3);
    return buttons.map((Button, index) => {
      return /*#__PURE__*/_react.default.createElement(Button, Object.assign({}, otherProps, {
        key: `button-${index}`,
        editorState: editorState,
        onChange: onChange,
        addKeyCommandListener: addKeyCommandListener,
        removeKeyCommandListener: removeKeyCommandListener
      }));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "draft-extend-controls"
    }, this.renderButtons());
  }
}
Toolbar.propTypes = {
  editorState: _propTypes.default.object,
  onChange: _propTypes.default.func,
  buttons: _propTypes.default.array,
  addKeyCommandListener: _propTypes.default.func.isRequired,
  removeKeyCommandListener: _propTypes.default.func.isRequired
};
Toolbar.childContextTypes = {
  getEditorState: _propTypes.default.func,
  onChange: _propTypes.default.func
};
var Toolbar$1 = exports.Toolbar = KeyCommandController(Toolbar);

// used to memoize accumulated options when rendering plugin wrapper components.

function memoize(func) {
  let _cache = (0, _immutable.Map)();
  return (...args) => {
    const argList = _immutable.List.of(...args);
    if (!_cache.has(argList)) {
      _cache = _cache.set(argList, func(...args));
    }
    return _cache.get(argList);
  };
}
var compose = (...funcs) => {
  return (...args) => {
    if (funcs.length === 0) {
      return args[0];
    }
    const last = funcs[funcs.length - 1];
    const rest = funcs.slice(0, -1);
    return rest.reduceRight((composed, f) => f(composed), last(...args));
  };
};

// plain objects with `{start, end}` values and non-HOF functions that return
// either a String or ReactElement
exports.compose = compose;
const middlewareAdapter = middleware => {
  if (middleware && middleware.__isMiddleware) {
    return middleware;
  }
  return next => (...args) => {
    if (typeof middleware === 'object') {
      // handle old blockToHTML objects
      const block = args[0];
      let objectResult;
      if (typeof block === 'string') {
        // handle case of inline style value
        const style = block;
        if (process.env.NODE_ENV === 'development') {
          console.warn('styleToHTML: Use of plain objects to define HTML output is being deprecated. Please switch to using functions that return a {start, end} object or ReactElement.');
        }
        objectResult = middleware[style];
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.warn('blockToHTML: Use of plain objects to define HTML output is being deprecated. Please switch to using functions that return a {start, end} object or ReactElement.');
        }
        objectResult = middleware[block.type];
      } // check for inline style value instead of a raw block

      if (objectResult !== null && objectResult !== undefined) {
        return objectResult;
      }
      return next(...args);
    }
    let returnValue;
    try {
      // try immediately giving the function the content data in case it's a simple
      // function that doesn't expect a `next` function
      const nonMiddlewareResult = middleware(...args);
      if (nonMiddlewareResult === null || nonMiddlewareResult === undefined) {
        // the behavior for non-middleware functions is to delegate by returning
        // `null` or `undefined`, so do delegation for them
        returnValue = next(...args);
      } else if (args.length === 2 && typeof args[1] === 'string' && args[1] === nonMiddlewareResult) {
        // entityToHTML option returned `originalText`, i.e. no change was made
        returnValue = next(...args);
      } else if (Array.isArray(nonMiddlewareResult)) {
        // returned an array from a textToEntity function, concat with next
        returnValue = nonMiddlewareResult.concat(next(...args));
      } else if (_immutable.OrderedSet.isOrderedSet(nonMiddlewareResult)) {
        // returned an OrderedSet from htmlToStyle, pass to next as third argument
        const previousStyles = args[args.length - 1];
        returnValue = previousStyles.union(nonMiddlewareResult).union(next(...args));
      } else if (typeof nonMiddlewareResult === 'function') {
        // most middleware HOFs will return another function when invoked, so we
        // can assume that it is one here
        returnValue = middleware(next)(...args);
      } else {
        // the function was a simple non-middleware function and
        // returned a reasonable value, so return its result
        returnValue = nonMiddlewareResult;
      }
    } catch (e) {
      // it's possible that trying to use a middleware function like a simple non-
      // middleware function will throw, so try it as a middleware HOF
      returnValue = middleware(next)(...args);
    } finally {
      return returnValue;
    }
  };
};

// utility function to accumulate the common plugin option function pattern of
// handling args by returning a non-null result or delegate to other plugins
const emptyFunction = () => {};
var accumulateFunction = (newFn, acc = emptyFunction) => {
  if (!newFn) {
    return acc;
  }
  return (...args) => {
    const result = newFn(...args);
    if (result === null || result === undefined) {
      return acc(...args);
    }
    return result;
  };
};
const emptyFunction$1 = () => {};
const emptyArray = [];
const emptyObject = {};
const memoizedAccumulateFunction = memoize(accumulateFunction);
const memoizedAssign = memoize((...args) => Object.assign({}, ...args));
const memoizedConcat = memoize((a1, a2) => a1.concat(a2));
const memoizedCoerceArray = memoize((arg = []) => Array.isArray(arg) ? arg : [arg]);
var accumulatePluginOptions = (accumulation, pluginConfig) => {
  const accumulationWithDefaults = Object.assign({
    styleMap: emptyObject,
    styleFn: emptyFunction$1,
    decorators: emptyArray,
    buttons: emptyArray,
    overlays: emptyArray,
    blockRendererFn: emptyFunction$1,
    blockStyleFn: emptyFunction$1,
    keyBindingFn: emptyFunction$1,
    keyCommandListeners: emptyArray
  }, accumulation);
  const {
    styleMap,
    styleFn,
    decorators,
    buttons,
    overlays,
    blockRendererFn,
    blockStyleFn,
    keyBindingFn,
    keyCommandListener
  } = pluginConfig;
  const keyCommandListeners = memoizedConcat(accumulationWithDefaults.keyCommandListeners, memoizedCoerceArray(keyCommandListener));
  return Object.assign({}, accumulationWithDefaults, {
    styleMap: memoizedAssign(accumulationWithDefaults.styleMap, styleMap),
    styleFn: memoizedAccumulateFunction(accumulationWithDefaults.styleFn, styleFn),
    decorators: memoizedConcat(accumulationWithDefaults.decorators, decorators),
    buttons: memoizedConcat(accumulationWithDefaults.buttons, buttons),
    overlays: memoizedConcat(accumulationWithDefaults.overlays, overlays),
    blockRendererFn: memoizedAccumulateFunction(blockRendererFn, accumulationWithDefaults.blockRendererFn),
    blockStyleFn: memoizedAccumulateFunction(blockStyleFn, accumulationWithDefaults.blockStyleFn),
    keyBindingFn: memoizedAccumulateFunction(keyBindingFn, accumulationWithDefaults.keyBindingFn),
    // `createPlugin` expects a singular `keyCommandListener`, but Editor
    // component props expect the plural `keyCommandListeners`, so return both
    // since this is used in both contexts
    keyCommandListeners,
    keyCommandListener: keyCommandListeners
  });
};
exports.accumulatePluginOptions = accumulatePluginOptions;
const emptyFunction$2 = () => {};
const emptyArray$1 = [];
const emptyObject$1 = {};
const defaultMiddlewareFunction = next => (...args) => next(...args);
defaultMiddlewareFunction.__isMiddleware = true;
const memoizedCoerceArray$1 = memoize(arg => Array.isArray(arg) ? arg : [arg]);
const memoizedPassEmptyStyles = memoize(func => (nodeName, node) => func(nodeName, node, (0, _immutable.OrderedSet)()));
const createPlugin = ({
  displayName = 'Plugin',
  // editor options
  decorators = emptyArray$1,
  buttons = emptyArray$1,
  overlays = emptyArray$1,
  styleMap = emptyObject$1,
  styleFn = emptyFunction$2,
  blockRendererFn = emptyFunction$2,
  blockStyleFn = emptyFunction$2,
  keyBindingFn = emptyFunction$2,
  keyCommandListener = emptyFunction$2,
  // HTML conversion options
  htmlToStyle = defaultMiddlewareFunction,
  htmlToBlock = defaultMiddlewareFunction,
  htmlToEntity = defaultMiddlewareFunction,
  textToEntity = defaultMiddlewareFunction,
  styleToHTML = defaultMiddlewareFunction,
  blockToHTML = defaultMiddlewareFunction,
  entityToHTML = defaultMiddlewareFunction
}) => ToWrap => {
  decorators = memoizedCoerceArray$1(decorators);
  buttons = memoizedCoerceArray$1(buttons);
  overlays = memoizedCoerceArray$1(overlays);
  if (ToWrap.prototype && ToWrap.prototype.isReactComponent) {
    // wrapping an Editor component
    class Plugin extends _react.default.Component {
      constructor(props) {
        super(props);
        this.focus = this.focus.bind(this);
        this.blur = this.blur.bind(this);
      }
      focus() {
        if (this.refs.child.focus) {
          this.refs.child.focus();
        }
      }
      blur() {
        if (this.refs.child.blur) {
          this.refs.child.blur();
        }
      }
      render() {
        const pluginAccumulation = accumulatePluginOptions({
          styleMap: this.props.styleMap,
          styleFn: this.props.styleFn,
          decorators: this.props.decorators,
          buttons: this.props.buttons,
          overlays: this.props.overlays,
          blockRendererFn: this.props.blockRendererFn,
          blockStyleFn: this.props.blockStyleFn,
          keyBindingFn: this.props.keyBindingFn,
          keyCommandListeners: this.props.keyCommandListeners
        }, {
          styleMap,
          styleFn,
          decorators,
          buttons,
          overlays,
          blockRendererFn,
          blockStyleFn,
          keyBindingFn,
          keyCommandListener
        }); // keyCommandListener isn't used by the Editor component or other plugin
        // HOCs but keyCommandListeners is

        const editorPluginOptions = (0, _objectWithoutPropertiesLoose2.default)(pluginAccumulation, _excluded4);
        return /*#__PURE__*/_react.default.createElement(ToWrap, Object.assign({}, this.props, {
          ref: "child"
        }, editorPluginOptions));
      }
    }
    Plugin.displayName = displayName;
    Plugin.propTypes = {
      styleMap: _propTypes.default.object,
      styleFn: _propTypes.default.func,
      decorators: _propTypes.default.array,
      buttons: _propTypes.default.array,
      overlays: _propTypes.default.array,
      blockRendererFn: _propTypes.default.func,
      blockStyleFn: _propTypes.default.func,
      keyBindingFn: _propTypes.default.func,
      keyCommandListeners: _propTypes.default.arrayOf(_propTypes.default.func)
    };
    Plugin.defaultProps = {
      styleMap: emptyObject$1,
      styleFn: emptyFunction$2,
      decorators: emptyArray$1,
      buttons: emptyArray$1,
      overlays: emptyArray$1,
      blockRendererFn: emptyFunction$2,
      blockStyleFn: emptyFunction$2,
      keyBindingFn: emptyFunction$2,
      keyCommandListeners: emptyArray$1
    };
    return Plugin;
  } else if (ToWrap && ToWrap.__isAccumulator) {
    return accumulatePluginOptions(ToWrap, {
      styleMap,
      styleFn,
      decorators,
      buttons,
      overlays,
      blockRendererFn,
      blockStyleFn,
      keyBindingFn,
      keyCommandListener
    });
  } else {
    // wrapping a converter function
    return (...args) => {
      if (args.length === 1 && (typeof args[0] === 'string' || args[0].hasOwnProperty('_map') && args[0].getBlockMap != null)) {
        // actively converting an HTML string/ContentState, so pass additional options to the next converter function.
        return ToWrap({
          htmlToStyle,
          htmlToBlock,
          htmlToEntity,
          textToEntity,
          styleToHTML,
          blockToHTML,
          entityToHTML
        })(...args);
      } else {
        // receiving a plugin to accumulate upon for a converter - accumulate
        // options and return a new plugin wrapped around the passed one ready
        // to take either another plugin or a string/ContentState
        const oldOptions = args[0];
        const newHTMLToStyle = compose(middlewareAdapter(memoizedPassEmptyStyles(htmlToStyle)), middlewareAdapter(oldOptions.htmlToStyle));
        newHTMLToStyle.__isMiddleware = true;
        const newHTMLToBlock = compose(middlewareAdapter(htmlToBlock), middlewareAdapter(oldOptions.htmlToBlock));
        newHTMLToBlock.__isMiddleware = true;
        const newHTMLToEntity = compose(middlewareAdapter(htmlToEntity), middlewareAdapter(oldOptions.htmlToEntity));
        newHTMLToEntity.__isMiddleware = true;
        const newTextToEntity = compose(middlewareAdapter(textToEntity), middlewareAdapter(oldOptions.textToEntity));
        newTextToEntity.__isMiddleware = true;
        const newStyleToHTML = compose(middlewareAdapter(styleToHTML), middlewareAdapter(oldOptions.styleToHTML));
        newStyleToHTML.__isMiddleware = true;
        const newBlockToHTML = compose(middlewareAdapter(blockToHTML), middlewareAdapter(oldOptions.blockToHTML));
        newBlockToHTML.__isMiddleware = true;
        const newEntityToHTML = compose(middlewareAdapter(entityToHTML), middlewareAdapter(oldOptions.entityToHTML));
        newEntityToHTML.__isMiddleware = true;
        return createPlugin({
          htmlToStyle: newHTMLToStyle,
          htmlToBlock: newHTMLToBlock,
          htmlToEntity: newHTMLToEntity,
          textToEntity: newTextToEntity,
          styleToHTML: newStyleToHTML,
          blockToHTML: newBlockToHTML,
          entityToHTML: newEntityToHTML
        })(ToWrap);
      }
    };
  }
};
exports.createPlugin = createPlugin;
const camelCaseToHyphen = camelCase => {
  return camelCase.replace(/[a-z][A-Z]/g, str => {
    return str[0] + '-' + str[1].toLowerCase();
  });
};
const getActiveEntity = editorState => {
  const currentBlock = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey());
  if (currentBlock) {
    return currentBlock.getEntityAt(editorState.getSelection().getStartOffset());
  }
};
var utils = exports.pluginUtils = {
  camelCaseToHyphen,
  styleObjectToString(styles) {
    return Object.keys(styles).map(styleName => {
      return `${camelCaseToHyphen(styleName)}: ${styles[styleName]};`;
    }).join(' ').replace(/"/g, '\\"');
  },
  entityStrategy: entityType => (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      if (entityKey === null) {
        return false;
      }
      const entity = contentState && contentState.getEntity ? contentState.getEntity(entityKey) : _draftJs.Entity.get(entityKey);
      return entity && entity.getType() === entityType;
    }, callback);
  },
  getEntitySelection(editorState, entityKey) {
    const selections = [];
    editorState.getCurrentContent().getBlocksAsArray().forEach(block => {
      block.findEntityRanges(c => c.getEntity() === entityKey, (start, end) => {
        selections.push(_draftJs.SelectionState.createEmpty(block.getKey()).merge({
          anchorOffset: start,
          focusOffset: end,
          isBackward: false,
          hasFocus: true
        }));
      });
    });
    invariant_1(selections.length === 1, 'getEntitySelection: More than one range with the same entityKey. Please use unique entity instances');
    return selections[0];
  },
  insertBlockAtCursor(editorState, block) {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    const afterRemoval = _draftJs.Modifier.removeRange(contentState, selectionState, 'backward');
    const targetSelection = afterRemoval.getSelectionAfter();
    const afterSplit = _draftJs.Modifier.splitBlock(afterRemoval, targetSelection);
    const insertionTarget = afterSplit.getSelectionAfter();
    const asType = _draftJs.Modifier.setBlockType(afterSplit, insertionTarget, block.getType());
    const fragmentArray = [block, new _draftJs.ContentBlock({
      key: (0, _draftJs.genKey)(),
      type: 'unstyled',
      text: '',
      characterList: (0, _immutable.List)()
    })];
    const fragment = _draftJs.BlockMapBuilder.createFromArray(fragmentArray);
    const withBlock = _draftJs.Modifier.replaceWithFragment(asType, insertionTarget, fragment);
    const newContent = withBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withBlock.getSelectionAfter().set('hasFocus', true)
    });
    return _draftJs.EditorState.push(editorState, newContent, 'insert-fragment');
  },
  getSelectedInlineStyles(editorState) {
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap().skipUntil((value, key) => {
      return key === selection.getStartKey();
    }).takeUntil((value, key) => {
      return contentState.getKeyBefore(key) === selection.getEndKey();
    });
    return blocks.reduce((styles, block) => {
      const blockKey = block.getKey();
      let start = 0;
      let end = block.getLength() - 1;
      if (blockKey === selection.getStartKey()) {
        start = selection.getStartOffset();
      }
      if (blockKey === selection.getEndKey()) {
        end = selection.getEndOffset();
      }
      for (let i = start; i <= end; i++) {
        styles = styles.union(block.getInlineStyleAt(i));
      }
      return styles;
    }, (0, _immutable.Set)());
  },
  matchAll(string, regex) {
    const result = [];
    let matchArray = regex.exec(string);
    while (matchArray !== null) {
      result.push(matchArray.concat([matchArray.index]));
      matchArray = regex.exec(string);
    }
    return result;
  },
  getActiveEntity,
  isEntityActive(editorState, entityType) {
    const activeEntityKey = getActiveEntity(editorState);
    const contentState = editorState.getCurrentContent();
    if (activeEntityKey) {
      const entity = contentState.getEntity ? contentState.getEntity(activeEntityKey) : _draftJs.Entity.get(activeEntityKey);
      return entity && entity.type === entityType;
    }
    return false;
  }
};
const withDraftExtendContext = Comp => {
  class ContextAwareComp extends _react.Component {
    render() {
      const draftContext = this.context;
      return /*#__PURE__*/_react.default.createElement(Comp, Object.assign({
        draftContext: draftContext
      }, this.props));
    }
  }
  ContextAwareComp.contextTypes = {
    getEditorState: _propTypes.default.func,
    getReadOnly: _propTypes.default.func,
    setReadOnly: _propTypes.default.func,
    onChange: _propTypes.default.func,
    focus: _propTypes.default.func,
    blur: _propTypes.default.func,
    editorRef: _propTypes.default.object
  };
  ContextAwareComp.WrappingComponent = Comp;
  return ContextAwareComp;
};
exports.withDraftExtendContext = withDraftExtendContext;